var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mastercard_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.667,
    height: 31,
    x: 4.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#F4F4F6",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M27.668 22.876a9 9 0 0 1-5.902 2.198c-5.025 0-9.098-4.12-9.098-9.204 0-5.083 4.073-9.203 9.098-9.203 2.252 0 4.313.827 5.902 2.198a9 9 0 0 1 5.902-2.198c5.024 0 9.098 4.12 9.098 9.204 0 5.083-4.074 9.204-9.098 9.204a9 9 0 0 1-5.902-2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M27.668 22.876a9.23 9.23 0 0 0 3.197-7.006 9.23 9.23 0 0 0-3.197-7.005 9 9 0 0 1 5.902-2.198c5.024 0 9.098 4.12 9.098 9.204 0 5.083-4.074 9.204-9.098 9.204a9 9 0 0 1-5.902-2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M27.67 8.865a9.23 9.23 0 0 1 3.196 7.006 9.23 9.23 0 0 1-3.197 7.005 9.23 9.23 0 0 1-3.196-7.006 9.23 9.23 0 0 1 3.196-7.005",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mastercard_svg__a",
    width: 54.668,
    height: 40,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_745_5488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_745_5488",
    result: "shape"
  })))));
};
export default SvgMastercard;